import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from '../../configuration.service';
import { UrlEndpoints } from 'src/app/definitions/url-endpoints';

@Injectable({
  providedIn: 'root'
})
export class DepotResourceService {

  constructor(private http: HttpClient,
    private configuration: ConfigurationService,
    private urlEndpoints: UrlEndpoints ) { }

  public getDepots() {
    return  this.http.get( this.configuration.buildUrl(this.urlEndpoints.depotListEndPoint) ).toPromise();
  }
}
